<footer>
    <p>Maknetic foto SL 2023® – Todos los derechos reservados. Tots els drets reservats. All rights reserved.<br>
    NIF B05457015 - 935 400 150 - 08238 Alella (Barcelona, España).<br>
    <a href="https://www.makneticfoto.com/aviso-legal/" target="_blank">{{ 'footer.legal_warning' | translate }}</a> - 
    <a href="https://www.makneticfoto.com/politica-privacidad/" target="_blank">{{ 'footer.privacy_policy' | translate }}</a> - 
    <a href="https://www.makneticfoto.com/condiciones-venta/" target="_blank">{{ 'footer.social_media_policy' | translate }}</a> - 
    <a href="https://makneticfoto.com/politica-cookies" target="_blank">{{ 'footer.cookies_policy' | translate }}</a> - 
    <a href="https://www.makneticfoto.com/condiciones-venta/" target="_blank">{{ 'footer.sold_conditions' | translate }}</a>
</p>

</footer>